import { BasiqInstitution } from "../../../../models/types/basiq.types";
import { InstitutionStoreModel } from "../../../../models/store/institution.store.model";
import { InstitutionView } from "../../../../models/view/institution/institution.view";
import { inject, Injectable } from "@angular/core";
import { DataPluginStoreService } from "../../../store/data-plugin/data-plugin.store.service";
import { InstitutionOriginEnum } from "@bitwarden/web-vault/app/models/types/institution.type";

@Injectable({
  providedIn: "root",
})
export class BasiqInstitutionMapper {
  protected dataPluginStore: DataPluginStoreService;

  constructor() {
    this.dataPluginStore = inject(DataPluginStoreService);
  }

  async map(basiqInstitutionDetails: BasiqInstitution) {
    const countries = this.dataPluginStore.theCountryList.theCountryViews();
    const country = countries.find(
      (country) => country.name.toLowerCase() === basiqInstitutionDetails.country.toLowerCase(),
    );
    const institutions = this.dataPluginStore.theInstitutionList.theInstitutionViews();
    // Null until the catalog loads (and after clear() or a failed fetch). Fail instead of creating a
    // bare institution: it would be saved, and later syncs skip institutions that already exist, so
    // the catalog's logos and products would never be applied. saveInstitutions() logs this and the
    // next sync retries.
    if (!institutions) {
      throw new Error("Institution catalog not loaded");
    }
    const institutionsOfCountry = institutions.filter(
      (testInstitution) => testInstitution.swift.countryCode === country.code,
    );
    const mappedInsto = institutionsOfCountry.find((institution) => {
      const insto = basiqInstitutionDetails.id === institution.instoBasiqId;

      if (insto) {
        for (const accountType of institution.availableAccounts) {
          accountType.id = crypto.randomUUID();
        }

        return institution;
      }
    });

    if (mappedInsto) {
      return mappedInsto;
    } else {
      const newGlossInstitutionObj: InstitutionStoreModel = {
        id: crypto.randomUUID(),
        vid: "",
        name: basiqInstitutionDetails.name,
        swt: {
          bac: null,
          cc: country.code,
          lc: null,
          brc: null,
        },
        bic: {
          bc: null,
          cc: country.code,
          lc: null,
        },
        fk: basiqInstitutionDetails.id,
        avaAcc: [],
        dc: new Date().toISOString(),
        v: 4,
        fskId: null,
        dm: new Date().toISOString(),
        fl_lg_url: mappedInsto?.full_logo_url,
        sq_lg_url: mappedInsto?.square_logo_url,
        org: InstitutionOriginEnum.auto,
        lnkT: null,
      };

      return new InstitutionView(newGlossInstitutionObj);
    }
  }
}
